import * as actionTypes from '../actionTypes'

import { saveFileFromResponse } from '../../../helpers/utils'
import { enqueueSnackbar } from '../alert'
import reportAxios from '../../../axios/report'

export const reportAppraisalByOrg = recordData => {
  return dispatch => {
    dispatch(reportAppraisalByOrgStart())

    reportAxios
      .post('/report_appraisal_report_by_org', recordData, { responseType: 'blob' })
      .then(response => {
        // if (recordData.format === 'xls') {
        saveFileFromResponse(response)
        // }
        dispatch(
          enqueueSnackbar({
            message: 'Report Appraisal By Org',
            options: {
              variant: 'success'
            }
          })
        )
        dispatch(reportAppraisalByOrgSuccess(response.data))
      })
      .catch(error => {
        switch (error.response.status) {
          case 400:
            dispatch(
              enqueueSnackbar({
                message: 'Error',
                options: {
                  variant: 'error',
                  data: error.response.data.data
                }
              })
            )
            break

          default:
            dispatch(
              enqueueSnackbar({
                message: 'Error Report Appraisal By Org',
                options: {
                  variant: 'error'
                }
              })
            )
            break
        }
        dispatch(reportAppraisalByOrgFailed())
      })
  }
}

export const reportAppraisalByOrgStart = () => {
  return {
    type: actionTypes.REPORT_APPRAISAL_BY_ORG_START
  }
}

export const reportAppraisalByOrgSuccess = data => {
  return {
    type: actionTypes.REPORT_APPRAISAL_BY_ORG_SUCCESS,
    data
  }
}

export const reportAppraisalByOrgFailed = () => {
  return {
    type: actionTypes.REPORT_APPRAISAL_BY_ORG_FAILED
  }
}

export const clearReportAppraisalByOrg = () => {
  return {
    type: actionTypes.CLEAR_REPORT_APPRAISAL_BY_ORG
  }
}
